const metricsState = {
    allMetrics: undefined,
    metrics: undefined,
    rackMetrics: undefined,
    requestingAllMetrics: false,
    requestingMetrics: false,
    requestingRackMetrics: false
};
export default metricsState;
